import { PrimeIcons } from "primereact/api";
import React, { FC, useContext } from "react";
import { useHistory } from "react-router-dom";
import { StoreProductQuantityLimitationService } from "../../domain";
import { GlobalContext } from "../../../../../context";
import { TawreedTable, TawreedTableColumnProps, TawreedTableProps } from "../../../../../common";
import { CssUtils } from "../../../../../helpers/css";
import { Button } from "primereact/button";
import { tawreedTranslationService } from "../../../../../common/translations";
import { AuthUtils } from "../../../../auth/domain";
import { Routes } from "../../../../../router";
import { TawreedAction, TawreedActionName } from "../../../../../common/actions";
import { StoreProductQuantityLimitation } from "../../data";


export interface QuantityLimitationTableProps {
}
export interface QuantityLimitationTableState {
    classification: number | undefined,
    ids: Array<number>
}
export interface ConnectionState {
    classification: number | undefined,
    fromId: number | undefined,
    toId: number | undefined,
}
/**
 *
 * @param param0
 * @returns
 */
export const QuantityLimitationTable: FC<QuantityLimitationTableProps> = ({ }) => {

    const service = new StoreProductQuantityLimitationService();
    const [reload, setReload] = React.useState(false);
    const [visible, setVisible] = React.useState(false);
    // const [addDialogVisible, setAddDialogVisible] = React.useState(false);
    // const [state, setState] = React.useState<ConnectionListState>({
    //     classification: undefined,
    //     ids: []
    // });
    const { auth: { user } } = React.useContext(GlobalContext);
    // const [addState, setAddState] = React.useState<ConnectionState>({
    //     classification: undefined,
    //     fromId: user?.roleCode === 'STORE_ADMIN' ? user.partnerId: undefined,
    //     toId: undefined
    // });

    const history = useHistory();

    // const Add = (): Promise<void> => {
    //     return new Promise((resolve) => {
    //         setAddDialogVisible(false);
    //         service.addClassification(addState.fromId!, addState.toId! ,addState.classification!).then((res) => {
    //             setReload(true);
    //         });
    //     });
    // }

    // const update = (): Promise<void> => {
    //     return new Promise((resolve) => {
    //         setVisible(false);
    //         service.setClassification(state.ids, state.classification!).then((res) => {
    //             setReload(true);
    //         });
    //     });
    // }
    // const onUpdate = (sender?: ConnectionDto | Array<ConnectionDto>): Promise<void> => {
    //     return new Promise((_resolve, reject) => {
    //         console.log(sender);
    //         if (!sender) {
    //             reject('No item selected');

    //         } else if (Array.isArray(sender)) {

    //             setReload(false);

    //             setState({ classification: undefined, ids: sender.map(item => item.partnerConnectionId) });
    //             setVisible(true);
    //         } else {
    //             setReload(false);

    //             setState({ classification: undefined, ids: [sender.partnerConnectionId] });
    //             setVisible(true);
    //         }
    //     })
    // }
    const onRemove = (sender?: StoreProductQuantityLimitation | Array<StoreProductQuantityLimitation>): Promise<void> => {
        return new Promise((_resolve, reject) => {
            if (!sender) {
                reject('No item selected');

            } else if (Array.isArray(sender)) {

                setReload(false);

                return service.deleteAll(sender.map(e => e.storeProductQuantityLimitationId!)).then(() => setReload(true)).catch(err => console.error(err));
            } else {
                setReload(false);
                return service.delete(sender.storeProductQuantityLimitationId!).then(() => setReload(true)).catch(err => console.error(err));
            }
        })
    }
    const onAdd = (): Promise<void> => {
        return new Promise((resolve) => {
            history.push(Routes.StoreProductQuantityLimitationNew);
        });
    }
    const getDependOnRole = () => {
        const arr = [];
        if (user?.roleCode !== 'STORE_ADMIN')
            arr.push({
                field: "store.partnerName",
                header: "lbl_store_products_quantity_limitation_store_name",
                filterField: "storeName",
                filter: true,
                sortField:"storeName",
                sortable:true,
                style: CssUtils.width('10%'),
            })
        return arr;
    }

    var columns: TawreedTableColumnProps[] = [

        {
            field: AuthUtils.current().language === 'en' ? "storeProduct.titleEn" : "storeProduct.titleAr",
            header: "lbl_store_products_quantity_limitation_title",
            sortable: true,
            sortField: AuthUtils.current().language === 'en' ? "titleEn" : "titleAr",
            filter: true,
            filterField: AuthUtils.current().language === 'en' ? "titleEn" : "titleAr",
            style: CssUtils.width(user?.roleCode !== 'STORE_ADMIN' ? '30%' : '40%', CssUtils.color('var(--danger-color)')),
            bodyStyle: { 'unicode-bidi': 'plaintext' },
        },
        ...getDependOnRole(),
        {
            field: "customer.partnerName",
            header: "lbl_store_products_quantity_limitation_customer_name",
            filterField: "customerName",
            sortField: "customerName",
            filter: true,
            sortable:true,
            style: user?.roleCode !== 'STORE_ADMIN' ? CssUtils.width('20%') : CssUtils.width('10%'),
        },
        {
            field: "classification",
            header: "lbl_store_products_quantity_limitation_classification",
            filterField: "classification",
            filter: true,
            sortable:true,
            style: user?.roleCode !== 'STORE_ADMIN' ? CssUtils.width('20%') : CssUtils.width('10%'),
        },
        {
            field: "priceListName",
            header: "lbl_store_products_quantity_limitation_price_list_name",
            filterField: "priceListName",
            sortField: "priceListName",
            filter: true,
            sortable:true,
            style: user?.roleCode !== 'STORE_ADMIN' ? CssUtils.width('20%') : CssUtils.width('10%'),
        },
        {
            field: "quantity",
            header: "lbl_store_products_quantity_limitation_quantity",
            filterField: "quantity",
            filter: true,
            sortable:true,
            style: user?.roleCode !== 'STORE_ADMIN' ? CssUtils.width('20%') : CssUtils.width('10%'),
        },
        {
            field: "actions",
            body: (options: any) => {
                return <React.Fragment>
                    <Button
                        type="button"
                        style={{ height: "35px" }}
                        icon={PrimeIcons.EYE}
                        className="p-button-success p-button-text"
                        tooltip={tawreedTranslationService.translate('lbl_info')}
                        onClick={() => {
                            history.push(Routes.StoreProductQuantityLimitationDetails.replace(':id', options!.storeProductQuantityLimitationId.toString()));

                        }} />
                </React.Fragment>
            },
            style: CssUtils.width('10%'),
        }
    ];
    const tawreed: TawreedTableProps = {
        header: true,
        pagination: true,
        reload: reload,
        dataKey: 'storeProductQuantityLimitationId',
        name: 'tbl.qunatity_limitation',
        title: 'lbl_qunatity_limitation',
        ds: {
            mode: 'lazy',
            onSearch: (req) => service.search(req),
        },
        columns: [
            ...columns,

        ],
        toolbar: {
            actions: [
                new TawreedAction(TawreedActionName.PartnerConnectionSetClassification, 'stateless', (e) => tawreedTranslationService.translate('lbl_add'), PrimeIcons.PLUS ,onAdd, 'p-button-text'),
                new TawreedAction(TawreedActionName.StoreProductQuantityLimitationDelete, 'statefull', (e) => tawreedTranslationService.translate('lbl_remove_limitation', e?.length ?? 0), PrimeIcons.TRASH, onRemove, 'p-button-danger ml-1 p-button-text', 'confirm'),
                // new TawreedAction(TawreedActionName.PartnerConnectionAddClassification, 'stateless', (e) => tawreedTranslationService.translate('lbl_add_connection'), PrimeIcons.PLUS, onAdd),
            ],
        },
        row: {},
        filter: {
            filterDisplay: 'menu',
            initial: {
                'titleEn': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'contains',
                        },
                    ]
                },
                'titleAr': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'contains',
                        },
                    ]
                },
                'customerName': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'contains',
                        },
                    ]
                },
                'storeName': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'contains',
                        },
                    ]
                },
                'classification': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'contains',
                        },
                    ]
                },
                'priceListName': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'contains',
                        },
                    ]
                }
            },
        },
        sort: {
            sortMode: 'single',
            initial: {
                sortField: 'storeProductQuantityLimitationId',
                sortOrder: 1,
                multiSortMeta: undefined,
            },
        },
        selection: {
            mode: 'checkbox',
        },
    }
    return (
        <React.Fragment>
            <TawreedTable  {...tawreed} />
        </React.Fragment>

    );
}